import { useTheme } from '@repo/theme';
import { Center, Pad, PadBox, WindowTitle } from 'component/basics';
import { Heading, UtilityText } from 'component/text';
import type { TLabel } from 'util/stdtypes';

import { RainCloudIllustration } from './errors-helpers';

export function HttpError({ code, label, cta }: { code: string; label: TLabel; cta?: any }) {
    const { colors } = useTheme();
    return (
        <Center>
            <WindowTitle label={label} />
            <Pad size={55} />
            <RainCloudIllustration />
            <Pad size={24} />
            <Heading center text={code} type='2xl' />
            <Pad size={4} />
            <PadBox horiz={20}>
                <UtilityText center={true} color={colors.colorTextSecondary} label={label} type='large' />
            </PadBox>
            <Pad size={24} />
            <Center>{cta}</Center>
        </Center>
    );
}
